// extracted by mini-css-extract-plugin
export default {"userMenu":"UserMenu_userMenu__A7t+F","userIcon":"UserMenu_userIcon__isek8"};